import { HttpClient } from "aurelia-fetch-client";
import { Router } from "aurelia-router";
import { autoinject } from "aurelia-framework";
import config from "../config/config";
import { State } from "./global-state";
import { SessionManager } from "./session-manager";

@autoinject
export class HTTPInjector {

	constructor(
        private state: State,
        private sessionManager: SessionManager,
        private http: HttpClient,
        private router: Router
    ) {
		const tokenUpdateUrl = `${config.hpfServiceUrl}/token`;
		const tokenUpdateMethod = "PUT";
        http.configure(c => {
            c
                .useStandardConfiguration()
                .withInterceptor({
                    request(request) {
                        // Check if we need to update jwt token, skip for service call to update endpoint
						let updateToken: boolean = false;
						if (!(request.method === tokenUpdateMethod && request.url === tokenUpdateUrl)) {
							updateToken = sessionManager.shouldUpdateToken()
						}

						sessionManager.resetSessionTimer(router, null, updateToken);

                        // Attatch jwtToken
						if (state.token) {
							if (request.headers.has("Authorization")) {
								request.headers.delete("Authorization");
							}
							request.headers.append("Authorization", `Bearer ${state.token}`);
						}

                        return request;
                    },
                    response(response) {
                        return response;
                    },
					responseError(response) {
						if (response.status == 401) {
							console.log(`Intercepted response ${response.status} using URL: ${response.url}`);
							if (!response.url.endsWith('/login')) {
								router.navigate('401');
							}
						}
						throw response;
					}
                });
        });
    }
}
